import(/* webpackMode: "eager" */ "/app/src/app/tools/color-palette/page.tsx");
